module.exports = __webpack_public_path__ + "static/media/schedule_structure_change_period_order.2856e83a.mov";